<div class="r2">
	<ui-alert
		*ngIf="participation.modalConfirm.display"
		[title]="participation.modalConfirm.title"
		[text]="participation.modalConfirm.text"
		(onAction)="participation.modalConfirm.cb($event)"
		[confirmText]="'Yes'"
		[cancelText]="'No'"
		[confirm]="true"
	></ui-alert>

	<ui-alert
		*ngIf="participation.modalAlert.display"
		[title]="participation.modalAlert.title"
		[text]="participation.modalAlert.text"
		(onAction)="participation.modalAlert.cb($event)"
	></ui-alert>

	<ui-modal [title]="lastTime.title" #modal [lg]="true" [class]="'with-scroll'">
		<ui-loading [loading]="lastTime.loading"></ui-loading>
		<table class="table ui-table">
			<tr *ngFor="let d of lastTime.data">
				<td><small>system</small>&nbsp;<b>{{ d.SystemBatchRow.SystemRole.System.Name }}</b>
				</td>
				<td>
					<small>role</small> {{ d.SystemBatchRow.MappedRoleName }}
				</td>
				<td>
					<span class="green color-green helper-capitalize" *ngIf="d.OverridenStatusId ==='approved' || (d.OverridenStatusId === null && d.StatusId==='approved')">
						accepted
					</span>
					<span class="red color-red helper-capitalize" *ngIf="d.OverridenStatusId ==='rejected' || (d.OverridenStatusId === null && d.StatusId==='rejected')">
						rejected
					</span>
				</td>
				<td>
					<span class="red color-red helper-capitalize" *ngIf="d.OverridenStatusId ==='rejected' || (d.OverridenStatusId === null && d.StatusId==='rejected')">
						{{ row_reasonDescription(d.OverridenStatusId == 'rejected' ? d.OverridenRejectionReason : d.RejectionReason) }}
					</span>
				</td>
			</tr>
		</table>
		<p *ngIf="lastTime.noResults">
			No report found in last reporting quarter
		</p>
		<button [hidden]="lastTime.loading || lastTime.noResults" class="btn btn-primary" (click)="lastTime_carryForward()">Carry
			Forward
		</button>
	</ui-modal>

	<ui-title [title]="participation.title"></ui-title>

	<p class="alert alert-warning" *ngIf="participation.reportAllowedAsApproverWhileBeingSuperApprover">
		This specific report was assigned to you as an Approver
	</p>

	<p class="alert alert-warning" *ngIf="participation.isSuperApprover">
		You are viewing this report as a Super Approver
	</p>

	<p class="alert alert-warning" *ngIf="participation.readonly && !participation.isSuperApprover && participation.entity.StatusId=='completed'">
		This screen is read-only as it has been completed by its approver
	</p>

	<p class="alert alert-success" *ngIf="participation.reportWasJustSavedByApprover">
		Thank you for completing this report, it is now read-only
	</p>


	<nav aria-label="breadcrumb" *ngIf="participation.id && !participation.loading">
		<ol class="breadcrumb">
			<li class="breadcrumb-item {{participation.entity.StatusId=='pending'?'active':''}}">
				<div>Pending</div>
			</li>
			<li class="breadcrumb-item  {{participation.entity.StatusId=='completed'?'active':''}}">
				<div>Completed</div>
			</li>
			<li class="breadcrumb-item  {{participation.entity.StatusId=='counter_signed'?'active':''}}">
				<div>Countersigned</div>
			</li>
		</ol>
	</nav>

	<div class="card mb-3" *ngIf="participation.entity.CompletedBy || participation.entity.CounterSignedBy || participation.entity.SORUserOverridenApproverId">
		<div class="card-body row">
			<div class="col-lg-4">
				<span *ngIf="participation.entity.CompletedBy">
					Completed by <b>{{ participation.entity.CompletedBy }}</b>,
					{{ participation.entity.CompletedDate|date:'dd/MM/yyyy' }}
				</span>
			</div>
			<div class="col-lg-4">
				<span *ngIf="participation.entity.CounterSignedBy">
					Countersigned by <b>{{ participation.entity.CounterSignedBy }}</b>,
					{{ participation.entity.CounterSignedDate|date:'dd/MM/yyyy' }}
				</span>
			</div>
			<div class="col-lg-4">
				<span *ngIf="participation.entity.SORUserOverridenApproverId">
					Reassigned from <b>{{ participation.entity.SORUserApprover?.FirstName }}
						{{ participation.entity.SORUserApprover?.LastName }}</b>,
					{{ participation.entity.SORUserOverridenApproverDate|date:'dd/MM/yyyy' }}
				</span>
			</div>
		</div>
	</div>


	<ui-loading class="mt-5" [loadingText]="'loading report'" [loading]="participation.loading"></ui-loading>
	<div *ngIf="participation.id && !participation.loading && !participation.saving"
		style="overflow-x:hidden;width:100%;">
		<!-- Column headers -->
		<div class="r" style="display:flex;flex-wrap:nowrap;align-items:center;width:100%;">
			<div class="c c1 h" style="flex-shrink:0;">User</div>
			<div class="c c2 h" style="flex-shrink:0;">System</div>
			<div class="c c3 h" style="flex-shrink:0;max-width:304px;overflow:hidden;">Role</div>
			<div class="c h" style="flex:0 0 150px;width:150px;min-width:150px;max-width:150px;">AD Group</div>
			<div class="c caction h" style="flex-shrink:0;white-space:nowrap;">Action</div>
			<div class="c creason h" style="flex-shrink:0;white-space:nowrap;">Reason</div>
		</div>
		<ng-container *ngFor="let r of participation.rows;let i = index">
			<!-- ── USER row ───────────────────────────────────────────────────── -->
			<div class="r r-user r-{{i}} {{participation.readonly?'participation-readonly':''}}" *ngIf="r.is==='user'"
				[hidden]="r.pairingId && (!r.firstPairing && !participation.rolePairingDisplay[r.pairingId])"
				style="display:flex;flex-wrap:nowrap;align-items:center;width:100%;">
				<!-- user name spans full width with blue underline -->
				<div class="c cuser">
					<small>user</small> {{ r.user }}
					<div *ngIf="r.userIsPrivileged" style="display:inline-block">
						-
						<span
							class="material-icons r-row-override-icon help material-icons-outlined red-important">security</span>
						<span class="red-important" style="margin-left:25px;">privileged account</span>
					</div>
				</div>
				<div class="c caction">
					<ui-input-radio-accept *ngIf="!participation.readonly && (!r.pairingId || r.firstPairing)"
						[hidden]="r.status=='saving' || (r.is!=='role' && participation.readonly)" [sm]="true"
						[textAccept]="'Accept'" [textReject]="'Reject'" [name]="'r'+r.id" [(ngModel)]="r.action"
						(changed)="row_onDecisionChange($event,r)" [noColors]="true">
					</ui-input-radio-accept>
					<button class="btn btn-sm btn-last-time mini"
						*ngIf="!participation.readonly && (!participation.isSuperApprover || participation.reportAllowedAsApproverWhileBeingSuperApprover)"
						(click)="lastTime_load(r.userId,r)">View Last</button>
				</div>
				<div class="c creason"></div>
			</div>
			<!-- ── SYSTEM row ─────────────────────────────────────────────────── -->
			<div class="r r-system r-{{i}} {{participation.readonly?'participation-readonly':''}}"
				*ngIf="r.is==='system'"
				[hidden]="r.pairingId && (!r.firstPairing && !participation.rolePairingDisplay[r.pairingId])"
				style="display:flex;flex-wrap:nowrap;width:100%;">
				<div class="c csystem"><small>system</small>&nbsp;<b>{{ r.system }}</b></div>
				<!-- <div class="c" style="flex:0 0 150px;width:150px;min-width:150px;max-width:150px;"></div> -->
				<div class="c caction">
					<ui-input-radio-accept *ngIf="!participation.readonly && (!r.pairingId || r.firstPairing)"
						[hidden]="r.status=='saving' || (r.is!=='role' && participation.readonly)" [sm]="true"
						[textAccept]="'Accept'" [textReject]="'Reject'" [name]="'r'+r.id" [(ngModel)]="r.action"
						(changed)="row_onDecisionChange($event,r)" [noColors]="true">
					</ui-input-radio-accept>
				</div>
				<div class="c creason"></div>
			</div>
			<!-- ── ROLE rows ──────────────────────────────────────────────────── -->
			<ng-container
				*ngIf="r.is==='role' && !(r.pairingId && (!r.firstPairing && !participation.rolePairingDisplay[r.pairingId]))">
				<ng-container *ngFor="let adGroup of (r.adGroups?.length > 0 ? r.adGroups : [null]);
                           let gi = index; let isFirst = first">
					<!-- First AD group row -->
					<div *ngIf="isFirst"
						class="r r-role r-{{i}}-{{gi}} {{participation.readonly?'participation-readonly':''}}"
						style="display:flex;flex-wrap:nowrap;align-items:center;">
						<div class="c c1" style="flex-shrink:0;visibility:hidden;"></div>
						<div class="c c2" style="flex-shrink:0;visibility:hidden;"></div>
						<div class="c c3"
							style="flex-shrink:0;max-width:304px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
							<!-- PAIRING role -->
							<div *ngIf="r.pairingId" class="role-pair"
								(click)="participation.rolePairingDisplay[r.pairingId] = !participation.rolePairingDisplay[r.pairingId]">
								<small>role</small>
								&nbsp;
								{{ r.pairing.Name }}
								<span *ngIf="participation.rolePairingDisplay[r.pairingId]">- {{ r.role }}</span>
								<div class="material-icons helper-clickable" [title]="'these roles are grouped, a user cannot have only one of them'">group</div>
							
							</div>
							<div *ngIf="!r.pairingId">
								<small>role</small>
								&nbsp;
								{{ r.role }}
							</div>
						</div>
						<!-- AD Group cell — fixed 150px -->
						<div class="c"
							style="flex:0 0 150px;width:150px;min-width:150px;max-width:150px;white-space:nowrap;overflow:hidden;"
							[matTooltip]="adGroup">
							<span *ngIf="adGroup" style="display:block;overflow:hidden;text-overflow:ellipsis;">{{
								adGroup }}</span>
						</div>
						<div class="c caction" style="flex-shrink:0;">
							<div *ngIf="participation.readonly">
								<span class="green color-green helper-capitalize" *ngIf="r.action===true">
									accepted
								</span>
								<span class="red color-red helper-capitalize" *ngIf="r.action===false">
									rejected
								</span>
							</div>
							<ui-input-radio-accept *ngIf="!participation.readonly && (!r.pairingId || r.firstPairing)"
								[hidden]="r.status=='saving'" [sm]="true" [textAccept]="'Accept'"
								[textReject]="'Reject'" [name]="'r'+r.id" [(ngModel)]="r.action"
								(changed)="row_onDecisionChange($event,r)" [noColors]="false">
							</ui-input-radio-accept>
							<span>&nbsp;</span>
							<span class="material-icons r-row-override-icon" *ngIf="r.isOverride"
								[matTooltip]="row_overrideDescription(r)">
								rule
							</span>

					<button class="btn btn-sm btn-last-time mini" *ngIf="r.is==='user' && (!r.pairingId || r.firstPairing) && !participation.readonly && (!participation.isSuperApprover || participation.reportAllowedAsApproverWhileBeingSuperApprover)"
							(click)="lastTime_load(r.userId,r)">View Last
					</button>
						</div>
						<div class="c creason" style="flex-shrink:0;"
							[style]="r.action===false && (!r.pairingId || r.firstPairing) && participation.readonly && row_reasonDescription(r.reason).length>32?'overflow-y:scroll;':''">
							<div class="r-loading" *ngIf="r.status=='saving'">
								<div class="spinner-border text-primary spinner-border-sm" role="status">
									<span class="sr-only"></span>
								</div>
							</div>
							<div class="r-error" *ngIf="r.status=='error'" style="color:#ae1414" (click)="row_saveChanges(r)">
								could not be saved, click to try again
							</div>
							<div *ngIf="r.action===false && participation.readonly && row_reasonDescription(r.reason)!='Rejection Reason'"
								class="red color-red helper-capitalize">
								<span>
									{{ row_reasonDescription(r.reason) }}
								</span>
							</div>
							<select name="r{{r.key}}"
								*ngIf="r.action===false && !participation.readonly && (!r.pairingId || r.firstPairing)"
								[hidden]="r.status=='saving'" class="form-control btn-sm select-decision" [ngModel]="r.reason" 
								(change)="row_onReasonChange($event.target['value'],r,$event)"

								>
								<option *ngFor="let rj of participation.rejectionResons" [value]="rj.key">
									{{ rj.value }}
								</option>
							</select>
							<span>&nbsp;</span>
						</div>
					</div>
					<!-- Non-first AD group rows -->
					<div *ngIf="!isFirst"
						class="r r-role r-{{i}}-{{gi}} {{participation.readonly?'participation-readonly':''}}"
						style="display:flex;flex-wrap:nowrap;align-items:center;padding-top:2px;padding-bottom:2px;min-height:0;">
						<div class="c c1" style="flex-shrink:0;visibility:hidden;"></div>
						<div class="c c2" style="flex-shrink:0;visibility:hidden;"></div>
						<div class="c c3" style="flex-shrink:0;max-width:304px;visibility:hidden;"></div>
						<div class="c"
							style="flex:0 0 150px;width:150px;min-width:150px;max-width:150px;white-space:nowrap;padding-top:0;padding-bottom:0;overflow:hidden;"
							[matTooltip]="adGroup">
							<span style="display:block;overflow:hidden;text-overflow:ellipsis;">{{ adGroup }}</span>
						</div>
						<div class="c caction" style="flex-shrink:0;"></div>
						<div class="c creason" style="flex-shrink:0;"></div>
					</div>
				</ng-container>
			</ng-container>
			<!-- Error indicator row -->
			<div *ngIf="participation.errors[i] && participation.errors[i].count>0" class="r r-error"
				style="display:flex;flex-wrap:nowrap;overflow:hidden;">
				<div class="c c1">&nbsp;</div>
				<div class="c c2">&nbsp;</div>
				<div class="c c3" style="max-width:304px;">&nbsp;</div>
				<div class="c" style="flex:0 0 150px;width:150px;min-width:150px;max-width:150px;">&nbsp;</div>
				<div class="c caction">
					<span class="r-alert-error r-alert-error-action" *ngIf="participation.errors[i].action"
						[matTooltip]="'Accept or Reject'">
						<span class="material-icons">
							error
						</span>
					</span>&nbsp;
				</div>
				<div class="c creason ">
					<span class="r-alert-error r-alert-error-reason" *ngIf="participation.errors[i].reason" [matTooltip]="'select a reason'">
						<span class="material-icons">
							error
						</span>
					</span>&nbsp;
				</div>
			</div>
		</ng-container>
	</div>

	<br>
	<br>
	<br>
	<br>
	<br>
	<br>
	<br>
	<br>
	<br>
	<br>
	<br>
	<br>

	<div class=" r-menu {{participation.entity.StatusId}}" *ngIf="participation.id && !participation.loading">

		<div *ngIf="participation.entity.StatusId!='pending'" class="row">
			<div class="col-lg-1" style="color: white;text-align: right;vertical-align: middle">
				Super<br>Approver<br>Notes
			</div>
			<div class="col-lg-9">
				<div *ngIf="participation.entity.StatusId=='counter_signed' || this.participation.readonly" style="height: 138px;overflow-y: scroll;white-space: pre-line" class="form-control">
					{{ participation.entity.Notes }}
				</div>
				<textarea style=" resize: none;"
					*ngIf="participation.entity.StatusId=='completed' && !this.participation.readonly"
					class="form-control" rows="5" name="counterisgnnotes" [(ngModel)]="participation.entity.Notes"></textarea>
			</div>
			<div class="col-lg-2" style="vertical-align: middle">
				<button class=" btn btn-primary "
					*ngIf="participation.entity.StatusId=='completed' && participation.isSuperApprover"
					[disabled]="participation.saving" (click)="override_submit()">Countersign
				</button>
				<div style="margin-top: 78px;margin-left: -19px;">
					<ui-loading [loading]="participation.saving"></ui-loading>
				</div>
			</div>
		</div>

		<div class="btns" *ngIf="!(participation.entity.StatusId=='completed' && participation.isSuperApprover)">
			<button class=" btn btn-primary"
				*ngIf="participation.entity.StatusId=='completed' && participation.isSuperApprover"
				[disabled]="participation.saving" (click)="override_submit()">Countersign
			</button>
			<button class=" btn btn-primary" *ngIf="participation.entity.StatusId=='pending' && !this.participation.readonly"
				[disabled]="participation.saving" (click)="participation_complete()">Complete Review
			</button>

			<div style="float: right;width: 25%;margin-top: 10px;">
				<ui-loading [loading]="participation.saving"></ui-loading>
			</div>
		</div>
	</div>
</div>
